import { Box, Typography } from '@mui/material'
import FeatureCard from '../common/FeatureCard'
import PrimaryButton from '../common/PrimaryButton'
import { plcFeatures } from '../../data/homeContent'
import {
  plcResidentialIcon,
  plcSpeakersIcon,
  plcCertificateIcon,
  sharedPlcTeamBuildingIcon,
} from '../../assets/index'
import {
  HOME_MOBILE_MQ,
  homeBodyTextSx,
  homeMobilePaddingX,
  homeSectionLabelSx,
  homeSectionPy,
} from './homeMobileLayout'

const plcFeatureConfig = [
  { title: plcFeatures[0], iconSrc: plcResidentialIcon, iconBgColor: 'rgba(183,7,7,0.12)' },
  { title: plcFeatures[1], iconSrc: plcSpeakersIcon, iconBgColor: 'rgba(183,142,7,0.12)' },
  { title: plcFeatures[2], iconSrc: sharedPlcTeamBuildingIcon, iconBgColor: 'rgba(115,183,7,0.12)' },
  { title: plcFeatures[3], iconSrc: plcCertificateIcon, iconBgColor: 'rgba(7,183,183,0.12)' },
]

const DESCRIPTION =
  'Join our transformative residential leadership camp designed to unlock your potential, build confidence, develop critical thinking skills, and prepare you for leadership roles in society. Experience intensive training with renowned speakers, interactive workshops, and life-changing activities.'

export default function PlcPreviewSection() {
  return (
    <Box
      component="section"
      sx={{
        width: '100%',
        maxWidth: 1920,
        mx: 'auto',
        px: homeMobilePaddingX,
        py: homeSectionPy,
        boxSizing: 'border-box',
      }}
    >
      <Box
        sx={{
          maxWidth: 1520,
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: { md: 'space-between' },
          alignItems: 'flex-start',
          gap: { xs: '32px', md: 6, lg: 0 },
          [HOME_MOBILE_MQ]: { gap: '32px' },
        }}
      >
        <Typography
          component="h2"
          sx={{
            ...homeSectionLabelSx,
            flexShrink: 0,
            position: { md: 'sticky' },
            top: { md: 100 },
            whiteSpace: { md: 'nowrap' },
          }}
        >
          Public Leadership Camp 4.0
        </Typography>

        <Box
          sx={{
            width: '100%',
            maxWidth: { md: 1000, lg: 1000 },
            display: 'flex',
            flexDirection: 'column',
            gap: { xs: '20px', md: 5, lg: '40px' },
            [HOME_MOBILE_MQ]: { gap: '20px' },
          }}
        >
          <Typography sx={homeBodyTextSx}>{DESCRIPTION}</Typography>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: { xs: '20px', lg: '24px' },
              [HOME_MOBILE_MQ]: { gap: '20px' },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                gap: { xs: '20px', lg: '24px' },
                [HOME_MOBILE_MQ]: { flexDirection: 'column', gap: '20px' },
              }}
            >
              {plcFeatureConfig.slice(0, 2).map((feature) => (
                <FeatureCard
                  key={feature.title}
                  {...feature}
                  sx={{
                    [HOME_MOBILE_MQ]: {
                      minHeight: 86,
                      p: '16px',
                      gap: '20px',
                      borderRadius: '16px',
                      '& > div:first-of-type': {
                        width: 54,
                        height: 54,
                        p: '13px',
                        '& img': { width: 28, height: 28 },
                      },
                      '& .MuiTypography-root': { fontSize: 16, lineHeight: 1.25 },
                    },
                  }}
                />
              ))}
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                gap: { xs: '20px', lg: '24px' },
                [HOME_MOBILE_MQ]: { flexDirection: 'column', gap: '20px' },
              }}
            >
              {plcFeatureConfig.slice(2, 4).map((feature) => (
                <FeatureCard
                  key={feature.title}
                  {...feature}
                  sx={{
                    [HOME_MOBILE_MQ]: {
                      minHeight: 86,
                      p: '16px',
                      gap: '20px',
                      borderRadius: '16px',
                      '& > div:first-of-type': {
                        width: 54,
                        height: 54,
                        p: '13px',
                        '& img': { width: 28, height: 28 },
                      },
                      '& .MuiTypography-root': { fontSize: 16, lineHeight: 1.25 },
                    },
                  }}
                />
              ))}
            </Box>
          </Box>

          <PrimaryButton
            to="/plc-4"
            sx={{
              alignSelf: { xs: 'flex-start', sm: 'flex-start' },
            }}
          >
            Learn More About PLC 4.0
          </PrimaryButton>
        </Box>
      </Box>
    </Box>
  )
}
